import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';

import { FormControlEx } from '../../../core/component/forms/form-control';
import { Article } from '../../model/article';
import { LeaseAgreementCategory, RentalObjectCategory } from '../../model/const/enums';
import { ArticleService } from '../../service/data/article.service';

@Component({
    selector: 'app-article-autocomplete',
    templateUrl: './article-autocomplete.component.html',
    styleUrls: ['./article-autocomplete.component.scss'],
    providers: [ArticleService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ArticleAutocompleteComponent implements OnDestroy {
  constructor(private service: ArticleService) {}

  private currency: string;
  @Input() articleId: string;
  @Input() category: LeaseAgreementCategory;
  @Input() control: FormControlEx;
  @Input() set currencyCode(code: string) {
    if (code && this.currency !== code) {
      this._subscription.unsubscribe();
      this.currency = code;
      this._subscription = this.service.getByCategory(this.category, code).subscribe(data => {
        if (data) {
          this.items = data;
          this.control.setValue(this.items.find(x => x.id === this.articleId));
        }
      });
    }
  }
  get currencyCode(): string {
    return this.currency;
  }

  private _subscription = new Subscription();
  items: Article[] = [];

  ngOnDestroy() {
    if (this._subscription) {
      this._subscription.unsubscribe();
      this._subscription = null;
    }
  }
}
